import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const ProfileRoute = lazy(() => import("@/pages/profile.page"));

export const Route = createFileRoute("/profile")({
  component: ProfileRoute,
});
